import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../../application/language/useI18n';
import { Colors } from '../color/Colors';

export interface IListItemLinkProperties {
  itemKey?: string;
  url: string;
  primaryText: string;
  secondaryText?: string;
  after?: React.ReactNode;
  icon?: any;
  color?: ListItemLinkColor;
  containerClassName?: string;
  primaryTextClassName?: string;
  secondaryTextClassName?: string;
  isSelected?: boolean;
  onClick?: () => void;
  dataCy?: string;
}

export enum ListItemLinkColor {
  default = 'default',
  light = 'light',
  danger = 'danger',
}

export const ListItemLink = ({
  color = ListItemLinkColor.default,
  itemKey,
  url,
  primaryText,
  secondaryText,
  after,
  icon = null,
  containerClassName = '',
  primaryTextClassName = '',
  secondaryTextClassName = '',
  isSelected,
  onClick = () => {},
  dataCy,
}: IListItemLinkProperties) => {
  const i18 = useI18n()
  const colorToStyleMap: any = {
    [ListItemLinkColor.default]: {},
    [ListItemLinkColor.light]: { color: Colors.primaryLight },
    [ListItemLinkColor.danger]: { color: Colors.errorLight },
  };
  const classes = useStyles();

  let linkTextStyle = colorToStyleMap[color] || colorToStyleMap[ListItemLinkColor.default];
  return (
    <ListItem
      className={isSelected ? classes.selected : containerClassName}
      style={linkTextStyle}
      key={itemKey}
      button
      component={Link}
      to={url}
      onClick={onClick}
      data-cy={dataCy}
    >
      {icon && <ListItemIcon children={icon} />}
      <ListItemText
        primaryTypographyProps={{ className: primaryTextClassName }}
        secondaryTypographyProps={{ className: secondaryTextClassName }}
        primary={i18.translate(primaryText)}
        secondary={secondaryText}
      />
      {after}
    </ListItem>
  );
};

const useStyles = makeStyles(() => ({
  selected: {
    backgroundColor: Colors.withOpacity(Colors.primary, 0.16),
  },
}));
